import comp from "./MealField";
export default comp;
